"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoredCardCvvDialog = StoredCardCvvDialog;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _cardGradient = require("./cardGradient");
/** Match the reference CVV confirmation modal while keeping CVV in a secure element. */
function StoredCardCvvDialog(_ref) {
  var card = _ref.card,
    cvvComplete = _ref.cvvComplete,
    isSubmitting = _ref.isSubmitting,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    status = _ref.status,
    targetId = _ref.targetId;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var _useTranslation2 = (0, _reactI18next.useTranslation)('payment'),
    tPayment = _useTranslation2.t;
  var gradient = (0, _cardGradient.getCardGradient)(card.cardType, card.brand);
  var cardBrand = (0, _cardGradient.normalizeCardBrand)(card.brand);
  var brandLabel = (0, _cardGradient.getCardBrandLabel)(card.brand);
  var type = tPayment(card.cardType === 'debit' ? 'saved_card.type_debit' : 'saved_card.type_credit');
  return /*#__PURE__*/_react["default"].createElement(_elements.Modal, {
    responsiveSize: "auto",
    contentHeight: "auto",
    expandedModal: true,
    defaultOpened: true,
    onCloseModal: onClose,
    rounded: "M",
    removeContentPadding: true,
    showCloseButton: false,
    "data-sentry-element": "Modal",
    "data-sentry-component": "StoredCardCvvDialog",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-[760px] max-w-[calc(100vw-120px)] px-6 pb-9 pt-8 max-sm:w-full max-sm:max-w-none max-sm:p-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between px-2.5 pb-[34px] pt-1"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "m-0 text-xl font-bold leading-tight text-gray-700"
  }, t('label.bt_form.cvv_confirmation_title')), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex h-9 w-9 items-center justify-center rounded-full border-0 bg-transparent",
    "aria-label": t('saved_card.close'),
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Close",
    color: "primary",
    size: "S",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-auto flex max-w-[460px] flex-col items-center gap-4 text-center"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "mx-auto mb-1 w-full max-w-[420px] text-base leading-[1.35] text-gray-600"
  }, t('label.bt_form.cvv_confirmation_message')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative flex min-h-[186px] w-full max-w-[340px] flex-col rounded-lg p-[14px] pt-4 text-white shadow-[0_8px_18px_rgba(15,23,42,0.24)] ".concat(gradient)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-start gap-2.5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-white p-[7px]"
  }, /*#__PURE__*/_react["default"].createElement(_elements.CreditCardIcon, {
    cardBrand: cardBrand,
    hasMargin: false,
    hideBorder: true,
    "data-sentry-element": "CreditCardIcon",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1 pt-0.5 text-left"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    mobileSize: "XS",
    weight: "bold",
    color: "white",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "capitalize"
  }, tPayment('saved_card.title', {
    brand: brandLabel,
    type: type
  }))), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    mobileSize: "XS",
    color: "white",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  }, "**** ", card.last4))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute bottom-[14px] left-[14px] right-[14px] flex items-center justify-between gap-2.5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    mobileSize: "XXS",
    color: "white",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  }, t('saved_card.expiration')), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    mobileSize: "XXS",
    color: "white",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  }, card.expirationLabel)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#ff6a00] bg-white/10",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "relative h-4 w-[30px] rounded-sm bg-white before:absolute before:left-1/2 before:top-1/2 before:h-[5px] before:w-[5px] before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:bg-gray-600 before:shadow-[-8px_0_0_#4b5563,8px_0_0_#4b5563]"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-0.5 w-full max-w-[340px] text-left"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: targetId,
    className: "mb-2 flex items-center gap-1.5 text-sm text-gray-600"
  }, t('label.bt_form.stored_card_cvv_label'), /*#__PURE__*/_react["default"].createElement("span", {
    title: t('label.bt_form.stored_card_cvv_tooltip'),
    className: "inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full border-2 border-gray-400 text-[11px] font-bold text-gray-500"
  }, "?")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: targetId,
    className: "flex h-12 w-full items-center rounded-[10px] px-3.5 pr-12 shadow-[0_2px_8px_rgba(15,23,42,0.12)]"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pointer-events-none absolute right-3 top-1/2 h-[18px] w-6 -translate-y-1/2 rounded-sm bg-gray-200 shadow-[inset_0_0_0_1px_#d1d5db]",
    "aria-hidden": "true"
  })), status === 'error' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/_react["default"].createElement(_elements.MessageBox, {
    title: t('label.problems_paying'),
    borderColor: "warning"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-end pt-[30px]"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full max-w-[335px] max-sm:max-w-none"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Button, {
    text: t('label.bt_form.cvv_confirmation_accept'),
    variant: "primary",
    onClick: onConfirm,
    fullWidth: true,
    fontSize: "S",
    padding: "S",
    isDisabled: !cvvComplete || status !== 'ready' || isSubmitting,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "StoredCardCvvDialog.tsx"
  })))));
}